"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DecreaseAnyProduction = void 0;
const CardName_1 = require("../CardName");
const Resources_1 = require("../Resources");
const MonsInsuranceBot_1 = require("../cards/automa/MonsInsuranceBot");
const SelectPlayer_1 = require("../inputs/SelectPlayer");
const DeferredAction_1 = require("./DeferredAction");
class DecreaseAnyProduction {
    constructor(player, resource, count = 1, title = 'Select player to decrease ' + resource + ' production by ' + count + ' step(s)') {
        this.player = player;
        this.resource = resource;
        this.count = count;
        this.title = title;
        this.priority = DeferredAction_1.Priority.ATTACK_OPPONENT;
    }
    execute() {
        var _a;
        if (this.player.game.isSoloMode()) {
            if (((_a = this.player.game.automaBotCorporation) === null || _a === void 0 ? void 0 : _a.name) === CardName_1.CardName.MONS_INSURANCE_BOT) {
                MonsInsuranceBot_1.MonsInsuranceBot.resolveMonsInsuranceBot(this.player);
            }
            return undefined;
        }
        if (this.player.isCorporation(CardName_1.CardName.BENTENMARU)) {
            this.player.addProduction(this.resource, this.count);
            return undefined;
        }
        let candidates = [];
        if (this.resource === Resources_1.Resources.MEGACREDITS) {
            candidates = this.player.game.getPlayers().filter((p) => p.getProduction(this.resource) >= this.count - 5);
        }
        else {
            candidates = this.player.game.getPlayers().filter((p) => p.getProduction(this.resource) >= this.count);
        }
        if (this.resource === Resources_1.Resources.STEEL || this.resource === Resources_1.Resources.TITANIUM) {
            candidates = candidates.filter((candidate) => !candidate.alloysAreProtected());
        }
        if (candidates.length === 0) {
            return undefined;
        }
        if (candidates.length === 1) {
            candidates[0].addProduction(this.resource, -this.count, { log: true, from: this.player });
            return undefined;
        }
        return new SelectPlayer_1.SelectPlayer(candidates, this.title, 'Decrease', (found) => {
            found.addProduction(this.resource, -this.count, { log: true, from: this.player });
            return undefined;
        });
    }
}
exports.DecreaseAnyProduction = DecreaseAnyProduction;
//# sourceMappingURL=DecreaseAnyProduction.js.map